'use strict';

import React from 'react';
import { connect } from 'react-redux';
import dispatchQuery from 'helpers/dispatchQuery';
import EntityRecommenderQuery from './entityRecommender.query';
import EntityRecommenderComponent from './entityRecommender.component';

class EntityRecommenderContainer extends React.Component {

  fetchEntitySuggestions (value) {
    const { dispatch } = this.props || this;
    const query = EntityRecommenderQuery.getSuggestions(value);
    dispatchQuery(dispatch, query, 'entitySuggestions', 'entitySuggestions');
  }

  fetchQuery (searchTerms) {
    const { dispatch } = this.props || this;
    this.fetchEntitiesWebPages(dispatch, searchTerms);
  }

  fetchEntitiesRecommendations (searchTerms) {
    const { dispatch } = this.props || this;
    const query = EntityRecommenderQuery.getRecommendations(searchTerms);
    dispatchQuery(dispatch, query, 'entityRecommendations', 'entityRecommendations');
  }

  fetchEntitiesWebPages (dispatch, searchTerms) {
    const query = EntityRecommenderQuery.getEntitiesWebPages(searchTerms);
    dispatchQuery(dispatch, query, 'entitiesWebPages', 'entitiesWebPages');
  }

  saveNewClassifier (classifierName, entityQuery) {
    const { dispatch } = this.props || this;
    const query = EntityRecommenderQuery.getMutationCreateClassifier(classifierName, entityQuery);
    dispatchQuery(dispatch, query, 'savedNewClassifier');
  }

  render() {
    return (
      <div className="Grid">
        <div className="Grid-cell--1">
          <div className="Grid-content">
            <EntityRecommenderComponent
              fetchEntitySuggestions={this.fetchEntitySuggestions}
              fetchEntitiesRecommendations={this.fetchEntitiesRecommendations.bind(this)}
              fetchQuery={this.fetchQuery.bind(this)}
              saveNewClassifier={this.saveNewClassifier.bind(this)}/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(EntityRecommenderContainer);



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.container.jsx